import * as tslib_1 from "tslib";
import getRelativeComplementOfComposeRecipients from '../utils/getRelativeComplementOfComposeRecipients';
import { logUsage } from 'owa-analytics';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import attachmentDatapoints from 'owa-attachment-well-data/lib/datapoints';
import { getCurrentTableMailboxInfo } from 'owa-mail-mailboxinfo';
import { getStore } from 'owa-mail-store/lib/store/Store';
import addRecipientToRecipientWell from 'owa-recipient-common/lib/actions/addRecipientToRecipientWell';
import removeRecipientFromRecipientWell from 'owa-recipient-common/lib/actions/removeRecipientFromRecipientWell';
import { orchestrator } from 'satcheljs';
import { infoBarAddHandler, infoBarRemoveHandler, infoBarGetIdsHandler, } from '../utils/infoBarHandlers';
import { includeMostRecentAttachmentsInfoBarMessage, INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID, } from 'owa-attachment-well-data/lib/utils/includeMostRecentAttachmentsInfoBarMessage';
var NO_RECIPIENTS_MESSAGEID = 'errorMessageNoRecipentsMailCanNotBeSend';
// Exported for testing purposes only
export var composeViewStates = [];
// Exported for testing purposes only
export var composeViewStatesWithActedOnMostRecentAttachmentsMessage = [];
export function subscribeToRecipientsChangeEvent(viewState) {
    composeViewStates.push(viewState);
}
export function unsubscribeToRecipientsChangeEvent(viewState) {
    var index = composeViewStates.indexOf(viewState);
    composeViewStates.splice(index, 1);
    index = composeViewStatesWithActedOnMostRecentAttachmentsMessage.indexOf(viewState);
    if (index !== -1) {
        composeViewStatesWithActedOnMostRecentAttachmentsMessage.splice(index, 1);
    }
}
orchestrator(addRecipientToRecipientWell, function (actionMessage) {
    updateInfoBarMessages(actionMessage.recipientWellRecipients, actionMessage.newRecipient.displayText);
});
orchestrator(removeRecipientFromRecipientWell, function (actionMessage) {
    updateInfoBarMessages(actionMessage.recipientWellRecipients);
});
export function updateInfoBarMessages(recipientWell, newRecipientName) {
    var currentViewState = null;
    var recipients = null;
    for (var _i = 0, composeViewStates_1 = composeViewStates; _i < composeViewStates_1.length; _i++) {
        var viewState = composeViewStates_1[_i];
        recipients = initializeRecipientArrays(viewState);
        if (isCurrentCompose(recipients, recipientWell.recipients)) {
            currentViewState = viewState;
            break;
        }
    }
    if (!currentViewState) {
        return;
    }
    if (newRecipientName) {
        removeNoRecipientsError(currentViewState);
        updateIncludeMostRecentAttachmentsMessage(currentViewState, recipients, newRecipientName);
    }
    else {
        updateIncludeMostRecentAttachmentsMessage(currentViewState, recipients);
    }
}
function removeNoRecipientsError(viewState) {
    // VSO 28792: When adding a recipient, remove the no recipients error message if this exists
    infoBarRemoveHandler(viewState)([NO_RECIPIENTS_MESSAGEID]);
}
// Exported for testing purposes only
export function updateIncludeMostRecentAttachmentsMessage(viewState, recipients, newRecipientName) {
    if (viewState.referenceItemId) {
        var item = getStore().items.get(viewState.referenceItemId.Id);
        if (item && !hasUserActedOnIncludeMostRecentAttachmentsMessage(viewState)) {
            var addedRecipientsInCompose = getRelativeComplementOfComposeRecipients(recipients, item);
            var numberOfAddedRecipientsInCompose = addedRecipientsInCompose.length;
            if (shouldIncludeMostRecentAttachmentsInfoBarMessage(viewState, item.HasAttachments, numberOfAddedRecipientsInCompose)) {
                logShowIncludeMostRecentAttachmentsMessageDatapoint(viewState);
                includeMostRecentAttachmentsInfoBarMessage(tslib_1.__assign({}, viewState.itemId, { mailboxInfo: getCurrentTableMailboxInfo() }), item, viewState.attachmentWell, recipients, numberOfAddedRecipientsInCompose === 1
                    ? addedRecipientsInCompose[0]
                    : newRecipientName, numberOfAddedRecipientsInCompose, infoBarAddHandler(viewState), infoBarRemoveHandler(viewState), updateActedComposeHandler(viewState));
            }
            else if (shouldRemoveMostRecentAttachmentsInfoBarMessage(viewState, numberOfAddedRecipientsInCompose)) {
                infoBarRemoveHandler(viewState)([INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID]);
            }
        }
    }
}
// Exported for testing purposes only
export function initializeRecipientArrays(viewState) {
    return {
        toRecipients: viewState.toRecipientWell ? viewState.toRecipientWell.recipients : [],
        ccRecipients: viewState.ccRecipientWell ? viewState.ccRecipientWell.recipients : [],
        bccRecipients: viewState.bccRecipientWell ? viewState.bccRecipientWell.recipients : [],
    };
}
function isCurrentCompose(recipients, currentRecipients) {
    return (recipients.toRecipients === currentRecipients ||
        recipients.ccRecipients === currentRecipients ||
        recipients.bccRecipients === currentRecipients);
}
// Exported for testing purposes only
export function shouldIncludeMostRecentAttachmentsInfoBarMessage(viewState, parentMessageHasAttachments, numberOfDistinctRecipientsAdded) {
    var composeOperation = viewState.operation;
    return (isAttachmentFeatureEnabled('doc-attachment-includeMostRecentAttachments') &&
        parentMessageHasAttachments &&
        numberOfDistinctRecipientsAdded > 0 &&
        (composeOperation === 1 /* Reply */ ||
            composeOperation === 2 /* ReplyAll */ ||
            composeOperation === 4 /* EditDraft */));
}
// Exported for testing purposes only
export function shouldRemoveMostRecentAttachmentsInfoBarMessage(viewState, numberOfDistinctRecipientsAdded) {
    return (isAttachmentFeatureEnabled('doc-attachment-includeMostRecentAttachments') &&
        isIncludeMostRecentAttachmentsInfoBarPresent(viewState) &&
        numberOfDistinctRecipientsAdded === 0);
}
function hasUserActedOnIncludeMostRecentAttachmentsMessage(viewState) {
    return composeViewStatesWithActedOnMostRecentAttachmentsMessage.indexOf(viewState) !== -1;
}
// Exported for testing reason only
export var updateActedComposeHandler = function (viewState) { return function () {
    composeViewStatesWithActedOnMostRecentAttachmentsMessage.push(viewState);
}; };
function isIncludeMostRecentAttachmentsInfoBarPresent(viewState) {
    var infoBarIds = infoBarGetIdsHandler(viewState)();
    return infoBarIds.indexOf(INCLUDE_MOST_RECENT_ATTACHMENTS_MESSAGEID) !== -1;
}
function logShowIncludeMostRecentAttachmentsMessageDatapoint(viewState) {
    if (!isIncludeMostRecentAttachmentsInfoBarPresent(viewState)) {
        logUsage(attachmentDatapoints.AttachmentShowIncludeMostRecentAttachmentsMessage.datapoint.name);
    }
}
//# sourceMappingURL=onRecipientsInComposeChange.js.map